/** @jsx jsx */

import { ComponentProps } from 'react';

import { Spinner } from '@zapier/design-system';
import { jsx, css } from '@emotion/core';

const sizes = {
  small: 20,
  medium: 30,
  large: 60,
};

const Styles = {
  root: (size = 'small') => css`
    margin: 0 auto;
    width: ${sizes[size]}px;
  `,
};

type Props = ComponentProps<typeof Spinner>;

/**
 * Renders a centered Spinner component
 * @param props
 * @returns JSX.Element
 */
const CenteredSpinner = (props: Props) => (
  <div css={Styles.root(props.size)}>
    <Spinner {...props} />
  </div>
);

export default CenteredSpinner;
